/**
 * @author Martin Leonov <martin.leonov@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import isNil from 'lodash/isNil';

/**
 * @import FileSystemUnitFinder from '../../file-system-unit-finder/file-system-unit-finder'
 * @import LogicalUnit from '../../logical-unit/logical-unit'
 * @import { LogicalUnitMapper } from '../../logical-unit-mapper'
 * @import { FileSystemManager } from '.'
 */

export default class FileSystemUtil {
  /**
   * Nalezne jednotku k uložení obsahu.
   * Zatím vždy vybere interní jednotku, u které očekává, že bude jediná přítomná tohoto typu.
   * Dočasná náhrada před implementací pokročilejšího výběru vhodných jednotek.
   * @param {FileSystemManager} fileSystemManager
   * @param {FileSystemUnitFinder} fileSystemUnitFinder
   * @param {LogicalUnitMapper} logicalUnitMapper
   * @param {string} storageString
   * @returns {Promise<LogicalUnit | null>} Nalezená primární jednotka.
   */
  static async find(
    fileSystemManager,
    fileSystemUnitFinder,
    logicalUnitMapper,
    storageString
  ) {
    // Získá všechny dostupné jednotky.
    const units = await fileSystemManager.getAllUnits();
    // Vyfiltruje jednotky dostupné pro uložení.
    const unit = await fileSystemUnitFinder.find(units, storageString);
    if (isNil(unit)) {
      return null;
    }

    // Provede mapování fyzických jednotek na logické.
    return logicalUnitMapper.toLogical(unit);
  }
}
